import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
interface Particle {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
}
export function ParticleField() {
  const particles = useMemo<Particle[]>(() => {
    return Array.from({
      length: 30
    }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 10 + 10,
      delay: Math.random() * 5
    }));
  }, []);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-38">
      {particles.map(particle => <motion.div key={particle.id} className="absolute rounded-full" style={{
      left: `${particle.x}%`,
      top: `${particle.y}%`,
      width: particle.size,
      height: particle.size,
      background: 'radial-gradient(circle, rgba(255,45,111,0.6) 0%, rgba(255,255,255,0.3) 100%)'
    }} animate={{
      y: [0, -30, 0],
      opacity: [0.3, 0.6, 0.3]
    }} transition={{
      duration: particle.duration,
      delay: particle.delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-39" />)}
    </div>;
}